import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { AddwithWhiteCircle, CrosswithGreyCircle, CrosswithWITECircle, DeleteDustbin, SearchBig, UpdatePencil } from '../AllSvg'
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { CSSForSelect, handleErrorToast } from '../custom';
import { useNavigate } from 'react-router-dom';


const AddQuatatations = ({ getNotes, worktypeName, getData }) => {
  const [formData, setFormData] = useState({
    ref_no: "",
    date: null,
    data: [{
      description: "",
    }],
    to: "",
    subject: "",
    project_details: "",
    worktype: [{
      id: "",
      name: "",
    }],
    note_ids: [],
    client_ids: [],
    notes: [],
    rate: [{
      description: ``,
      amount: ``,
    }],
    workstages: [{
      workStages: "",
      percentage: "",
    }],

    termsandconditions: [{
      item: ""
    }],

    structured_field: [
      {
        usedfor: "",
        total: "",
        work_type_rate: "",
        Data: [
          {
            heading: "",
            Data: [{
              item: "",
            }]
          }
        ]
      }
    ],

    subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",

  });


  console.log("formData")





  const [subcompany, setSubCompany] = useState([])
  const getSubCompany = async () => {

    try {
      const res = await axios.get(`${BASE_URL}/project/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
    }
  };

  useEffect(() => {
    getSubCompany();
  }, [])

  const company_name = sessionStorage.getItem('sub_company_name');
  const subcompanyId = subcompany.filter(i => i.title === company_name);

  console.log("company_name", company_name);
  console.log("subcompanyId", subcompanyId);


  const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;
  const companyids = sessionStorage.getItem('sub_company_id');

  console.log("company_id", company_id);

  const [clientData, setClientData] = useState([]);


  const getClientData = async () => {

    try {
      const res = await axios.get(`${BASE_URL}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`);

      if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
        setClientData(res.data.filter(i => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"))

      }
      else {
        setClientData(res.data)

      }
    } catch (err) {
      //toast Logic
      if (err.response) {
        const errorData = err.response.data;

        if (typeof errorData.error === 'string') {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
    }
  }
  useEffect(() => {

    getClientData();
  }, [company_id]);



  const [isSubmitted, setIsSubmitted] = useState(false);

  const [show, setShow] = useState(false);

  const handleShow = () => {

    setShow(true);
    getCompany();
  }

  const handleClose = () => {
    setShow(false);

    setFormData({
      ref_no: "",
      date: null,
      data: [{
        description: "",
      }],
      to: "",
      subject: "",
      project_details: "",
      worktype: [{
        id: "",
        name: "",
      }],
      note_ids: [],
      client_ids: [],
      notes: [],
      rate: [{
        description: ``,
        amount: ``,
      }],
      workstages: [{
        workStages: "",
        percentage: "",
      }],

      termsandconditions: [{
        item: ""
      }],

      structured_field: [
        {
          usedfor: "",
          total: "",
          work_type_rate: "",
          Data: [
            {
              heading: "",
              Data: [{
                item: "",
              }]
            }
          ]
        }
      ],

      subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",
    })
    setErrors({

    });
  }

  const [searchTerm, setSearchTerm] = useState("");

  const ClientListData = (clientData || [])
    .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({
      value: i.id,
      label: `${index + 1}. ${i.title}`,
    }));

  const handleClientChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        to: "",
      });
    } else {
      setFormData({
        ...formData,
        to: selectedOption.value,
      });
    }
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };
  const workTypeDatra = (worktypeName || [])
    .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({
      value: i.id,
      label: `${index + 1}. ${i.title}`,
    }));

  const handleWorkTypeChange = (selectedOptions) => {
    if (!selectedOptions) {
      setFormData({
        ...formData,
        worktype: [],
      });
    } else {
      setFormData({
        ...formData,
        worktype: selectedOptions.map(option => ({
          id: option.value,
          name: option.label.replace(/^\d+\.\s/, '')
        })),
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.worktype_id;
      return updatedErrors;
    });
  };


  useEffect(() => {
    setFormData(prev => {
      if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;

      const workstages = prev.termsandconditions.map(tc => {
        const match = tc.item.match(/^(\d+)%\s*(.*)$/);
        return {
          percentage: match ? parseFloat(match[1]) : 0,
          workStages: match ? match[2].trim() : ""
        };
      });

      return { ...prev, workstages };
    });
  }, [formData.termsandconditions]);


  console.log("formData")
  console.log(formData)

  useEffect(() => {
    const filteredNotes = getNotes.filter(note =>
      (formData.worktype || []).some(wt => wt.id === note.worktype?.id)
    );


    const notesId = filteredNotes.map((i) => (
      i.id
    ))

    setFormData((prev) => ({
      ...prev,
      notes: filteredNotes,
      note_ids: notesId

    }));
  }, [getNotes, formData.worktype]);

  useEffect(() => {
    if (!formData.worktype || formData.worktype.length === 0) {
      return;
    }

    setFormData(prev => {
      const newFields = formData.worktype.map(wt => {
        const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
        return existing || {
          usedfor: wt.name,
          Data: [
            {
              heading: "",
              Data: [{ item: "" }]
            }
          ]
        };
      });

      return {
        ...prev,
        structured_field: newFields
      };
    });
  }, [formData.worktype]);








  const addNewDescription = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      termsandconditions: [...prevFormData.termsandconditions, { item: "" }],
    }));
  };

  const handleDescriptionChange = (index, value) => {
    const updatedData = [...formData.termsandconditions];


    if (!updatedData[index]) {
      updatedData[index] = { item: "" };
    }

    updatedData[index].item = value;
    setFormData({ ...formData, termsandconditions: updatedData });


    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`item_${index}`];
        return updatedErrors;
      });
    }
  };

  const handleWorkTypeRateChange = (usedfor, value) => {
    setFormData(prev => {
      const structured_field = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          return { ...sf, worktype_rate: value };
        }
        return sf;
      });

      return { ...prev, structured_field };
    });
  };


  const fileInputRefs = useRef([]);

  const handleRemoveData = (index) => {
    setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };


  const [errors, setErrors] = useState({});

  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "null") {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });



    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };



  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {

      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true);
      try {
        let res = await axios.post(`${BASE_URL}/project/quotations/`, formData);

        if (res.status === 200 || res.status === 201) {
          getData();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Quotation Added successfully!");

        } else {
          alert(res);
        }
      } catch (err) {
        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;

          if (typeof errorData.error === 'string') {
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach(message => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error('Error:- Failed to Process!');
          }
        } else {
          toast.error('Error processing your request.');
        }
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }

    }
  };
  const [company, setCompany] = useState([]);

  const getCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/project/subcompany/`);
      setCompany(res.data);
    } catch (error) {
      console.error(error);

    }
  }




  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value,
    });

    setFormData({
      ...formData,
      [name]: value,
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };


  const removeDescription = (index) => {
    const updatedData = formData.termsandconditions.filter((_, i) => i !== index);
    setFormData({ ...formData, termsandconditions: updatedData });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`item_${index}`];

      const reorderedErrors = {};
      Object.keys(updatedErrors).forEach((key) => {
        if (key.startsWith("item_")) {
          const idx = parseInt(key.split("_")[1], 10);
          reorderedErrors[
            `item_${idx > index ? idx - 1 : idx}`
          ] = updatedErrors[key];
        } else {
          reorderedErrors[key] = updatedErrors[key];
        }
      });

      return reorderedErrors;
    });
  };



  const [expandedTables, setExpandedTables] = useState({});

  const toggleTable = (usedfor) => {
    setExpandedTables((prev) => {
      const isOpen = prev[usedfor];

      if (isOpen) {

        setFormData((prevFormData) => ({
          ...prevFormData,
          structured_field: prevFormData.structured_field.map((sf) =>
            sf.usedfor === usedfor
              ? {
                ...sf,
                Data: [
                  {
                    heading: "",
                    Data: [{ item: "" }],
                  },
                ],
                worktype_rate: "",
                total: 0,
              }
              : sf
          ),
        }));

        return { ...prev, [usedfor]: false };
      } else {

        return { ...prev, [usedfor]: true };
      }
    });
  };

























  const addRateRow = () => {
    setFormData((prev) => ({
      ...prev,
      rate: [...prev.rate, { description: "", amount: "" }],
    }));
  };


  const removeRateRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.filter((_, i) => i !== index),
    }));
  };


  const handleRateChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };



  const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
    setFormData(prev => {
      const structured_field = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((headingObj, hIdx) => {
            if (hIdx === headingIndex) {

              const updatedItems = [...(headingObj.Data || [])];
              while (updatedItems.length <= itemIndex) {
                updatedItems.push({ item: "" });
              }
              updatedItems[itemIndex] = { item: value };
              return { ...headingObj, Data: updatedItems };
            }
            return headingObj;
          });
          return { ...sf, Data: updatedData };
        }
        return sf;
      });
      return { ...prev, structured_field };
    });
  };

  useEffect(() => {
    if (!formData.worktype || formData.worktype.length === 0) {
      return;
    }

    setFormData(prev => {
      const newFields = formData.worktype.map(wt => {
        const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
        return existing || {
          usedfor: wt.name,
          Data: [
            {
              heading: "",
              Data: [{ item: "" }]
            }
          ]
        };
      });

      return {
        ...prev,
        structured_field: newFields
      };
    });
  }, [formData.worktype]);



  const addNewHeading = (usedfor) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          return {
            ...sf,
            Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }]
          };
        }
        return sf;
      });

      return {
        ...prev,
        structured_field: updatedStructuredField
      };
    });
  };

  const handleRemoveDescription = (noteIndex, descIndex) => {
    setFormData((prev) => {
      const updatedNotes = [...prev.notes];
      updatedNotes[noteIndex].data = updatedNotes[noteIndex].data.filter(
        (_, i) => i !== descIndex
      );




      return { ...prev, notes: updatedNotes };
    });
  };

  const handleHeadingChange = (usedfor, headingIndex, value) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((hdg, idx) => {
            if (idx === headingIndex) {
              return { ...hdg, heading: value };
            }
            return hdg;
          });
          return { ...sf, Data: updatedData };
        }
        return sf;
      });

      return { ...prev, structured_field: updatedStructuredField };
    });
  };

  const generateRows = (structuredField) => {
    const maxLength = Math.max(...structuredField.Data.map(h => h.Data.length));

    const rows = Array.from({ length: maxLength }, (_, rowIndex) =>
      structuredField.Data.map((headingObj) => {
        return headingObj.Data[rowIndex] || { item: "" };
      })
    );

    return rows;
  };

  const addNewItemToAllHeadings = (usedfor) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((headingObj) => ({
            ...headingObj,
            Data: [...headingObj.Data, { item: "" }]
          }));
          return {
            ...sf,
            Data: updatedData
          };
        }
        return sf;
      });

      return {
        ...prev,
        structured_field: updatedStructuredField
      };
    });
  };

  const handleRemoveRow = (usedfor, rowIndex) => {
    setFormData(prev => {
      const updated = { ...prev };
      const section = updated.structured_field.find(sf => sf.usedfor === usedfor);

      if (section && section.Data?.length > 0) {
        section.Data.forEach(col => {
          if (col?.Data && col.Data[rowIndex] !== undefined) {
            col.Data.splice(rowIndex, 1);
          }
        });
      }

      return { ...updated };
    });
  };
  const removeColumn = (usedfor, headingIndex) => {
    setFormData((prev) => {
      const updatedFields = prev.structured_field.map((field) => {
        if (field.usedfor === usedfor) {

          const newData = field.Data.filter((_, index) => index !== headingIndex);


          const updatedData = newData.map((headingObj) => {
            return {
              ...headingObj,
              Data: headingObj.Data.map((cellObj) => cellObj)
            };
          });

          return { ...field, Data: updatedData };
        }
        return field;
      });

      return { ...prev, structured_field: updatedFields };
    });
  };



  return (
    <>
      <button className='upload-svg' onClick={handleShow}>
        <AddwithWhiteCircle /> {"Quotations"}
      </button>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
        <Modal.Header closeButton>
          <Modal.Title>Add Quotation Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">

            <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

              <div className="flex-column ">
                <label className="form-labels">Ref. Number:<span className="required">*</span></label>
                <input
                  type="text"
                  name="ref_no"
                  value={formData.ref_no}
                  placeholder="Example:- ABCD/EFG/2025-26/456"
                  onChange={handleInputChange}
                  className={`form-input width-15vw ${errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.ref_no && <span className="error-message">{errors.ref_no}</span>}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Date:<span className="required">*</span></label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  placeholder="Example:- ABCD/EFG/2025-26/456"
                  onChange={handleInputChange}
                  className={`form-input width-15vw ${errors.date ? 'error' : inputState.date ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.date && <span className="error-message">{errors.date}</span>}
              </div>
              <div className="form-group">
                <label
                  htmlFor="to"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Client Name <span className="required">*</span>
                </label>
                <Select
                  options={ClientListData}
                  onChange={handleClientChange}
                  value={ClientListData.find(option => formData.to === option.value) || null}
                  placeholder="Select a Client"
                  isClearable
                  isSearchable
                  isMulti={false}
                  inputValue={searchTerm}
                  onInputChange={(input) => setSearchTerm(input)}
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect}
                />


                {errors.to && (
                  <div className="error-message col">
                    {errors.to}
                  </div>
                )}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Subject:<span className="required">*</span></label>
                <textarea
                  type="text"
                  name="subject"
                  value={formData.subject}
                  placeholder="Example:-  Quotation for Consultancy Services"
                  onChange={handleInputChange}
                  className={`form-input-textarea width-15vw ${errors.subject ? 'error' : inputState.subject ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.subject && <span className="error-message">{errors.subject}</span>}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Project Details:<span className="required">*</span></label>
                <textarea
                  type="text"
                  name="project_details"
                  value={formData.project_details}
                  placeholder="Example:- Corporate HQ"
                  onChange={handleInputChange}
                  className={`form-input-textarea width-15vw ${errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.project_details && <span className="error-message">{errors.project_details}</span>}
              </div>
              <div className="form-group">
                <label
                  htmlFor="to"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  WorkType <span className="required">*</span>
                </label>
                <Select
                  options={workTypeDatra}
                  onChange={handleWorkTypeChange}
                  value={workTypeDatra.filter(option =>
                    formData.worktype.some(wt => wt.id === option.value)
                  )}
                  placeholder="Select Work Types"
                  isClearable
                  isSearchable
                  isMulti
                  inputValue={searchTerm}
                  onInputChange={(input) => setSearchTerm(input)}
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect}
                />
                {errors.to && (
                  <div className="error-message col">
                    {errors.to}
                  </div>
                )}
              </div>


              {formData.notes?.length > 0 && (
                <table className="nested-table-lightblue width-90vw payment border-table">
                  <thead className="border-table">
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>S.No.</th>
                      <th className="text-start">Notes Description</th>

                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      let serial = 1;
                      return formData.notes.map((note, noteIndex) =>
                        note.data.map((desc, descIndex) => {
                          const currentSerial = serial++;
                          return (
                            <tr key={`${note.id}-${descIndex}`}>
                              <td className="font-weight600 text-center">{currentSerial}.</td>
                              <td className="notes-description">{desc.description}</td>

                            </tr>
                          );
                        })
                      );
                    })()}
                  </tbody>
                </table>
              )}

              <div style={{ display: "flex", justifyContent: "end", width: `100%`, marginBottom: `40px` }}>

                <div className="flex-column " >

                  <button className="viewbutton" onClick={addNewDescription}>
                    <AddwithWhiteCircle />  More Conditions
                  </button>
                </div>
              </div>
              <div>


              </div>

            </div>

            <div className='flex-row justify-between' style={{ flexWrap: "wrap" }}>

              {formData.termsandconditions?.map((item, index) => (
                <div className="flex-column ">
                  <div className='flex-row justify-between'>
                    <label className="form-labels">({index + 1}).PAYMENT TERMS AND CONDITION :<span className="required">*</span></label>
                    {formData.termsandconditions.length > 1 &&


                      <button className="removebutton" onClick={() => removeDescription(index)}>
                        <span className="text"
                        >Remove</span><span className="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z">
                            </path>
                          </svg>
                        </span>
                      </button>
                    }
                  </div>

                  <input
                    type="text"
                    name={`item_${index}`}
                    value={item.item}
                    placeholder="Example:- 50% payment as ABC work"
                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                    className={`form-input ${errors[`item_${index}`] ? 'error' : inputState[`item_${index}`] ? 'success' : ''}`}
                  />
                  {errors[`item_${index}`] && (
                    <div className="error-message text-center">{errors[`item_${index}`]}</div>
                  )}                </div>
              ))}
            </div>


            <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap", gap: "10px" }}>
              {formData.notes?.length > 0 &&
                formData.structured_field?.map((i) => (
                  <div className="flex-column" key={i.usedfor}>
                    <button
                      type="button"
                      className={expandedTables[i.usedfor] ? "viewbutton" : "viewbutton"}
                      onClick={() => toggleTable(i.usedfor)}
                    >
                      {expandedTables[i.usedfor] ? (
                        <>
                          <CrosswithWITECircle /> Hide {i.usedfor} Detailed Proposal
                        </>
                      ) : (
                        <>
                          <AddwithWhiteCircle /> Add {i.usedfor} Detailed Proposal
                        </>
                      )}
                    </button>
                  </div>
                ))}
            </div>

            {/* ✅ Tables */}
            {formData.notes?.length > 0 &&
              formData.structured_field?.map((i, index) => (
                <div key={i.usedfor}>
                  {expandedTables[i.usedfor] && (
                    <>
                      <h6>({index + 1}). Detailed Proposal of {i.usedfor}</h6>
                      <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>
                          <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                            <thead className="table-heading">
                              <tr
                                className="custom-table-head-tr"
                                style={{ border: "1px solid #1a5276", padding: "8px", color: "#1a5276" }}
                              >
                                <th
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                    color: "#1a5276",
                                  }}
                                >
                                  S.No.
                                </th>

                                {i.Data.map((headingObj, headingIndex) => (
                                  <th
                                    key={headingIndex}
                                    style={{
                                      border: "1px solid #1a5276",
                                      padding: "8px",
                                      background: "#e5dfec",
                                    }}
                                  >
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                      <input
                                        type="text"
                                        value={headingObj.heading}
                                        placeholder="Enter heading"
                                        className="input"
                                        onChange={(e) =>
                                          handleHeadingChange(i.usedfor, headingIndex, e.target.value)
                                        }
                                      />
                                      <button
                                        type="button"
                                        style={{
                                          background: "#ff6b6b",
                                          border: "none",
                                          color: "BLACK",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                        }}
                                        onClick={() => removeColumn(i.usedfor, headingIndex)}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  </th>
                                ))}

                                <th
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                >
                                  <button
                                    className="viewbutton"
                                    onClick={() => addNewHeading(i.usedfor)}
                                  >
                                    <AddwithWhiteCircle /> Heading
                                  </button>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {generateRows(i).map((row, rowIndex) => (
                                <tr className="custom-table-head-tr" key={rowIndex}>
                                  <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
                                    {rowIndex + 1}
                                  </td>

                                  {row.map((cell, cellIndex) => (
                                    <td
                                      key={cellIndex}
                                      style={{ border: "1px solid #1a5276", padding: "8px" }}
                                    >
                                      <input
                                        type="text"
                                        value={cell.item}
                                        className="input"
                                        placeholder="Enter item"
                                        onChange={(e) =>
                                          handleStructuredFieldChange(
                                            i.usedfor,
                                            cellIndex,
                                            rowIndex,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                  ))}

                                  <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
                                    {rowIndex === 0 ? (
                                      <button
                                        type="button"
                                        className="viewbutton"
                                        onClick={() => addNewItemToAllHeadings(i.usedfor)}
                                      >
                                        <AddwithWhiteCircle /> Row
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="viewbutton"
                                        onClick={() => handleRemoveRow(i.usedfor, rowIndex)}
                                      >
                                        <CrosswithWITECircle /> Remove
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}

                              {/* ✅ Work Type Rate Row */}
                              <tr className="total-row">
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                ></td>
                                <td
                                  className="text-end"
                                  colSpan={generateRows(i)[0]?.length - 1 || 1}
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                >
                                  {i.usedfor}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                >
                                  <input
                                    type="number"
                                    className="input"
                                    value={i.worktype_rate || ""}
                                    placeholder="Enter work type rate"
                                    onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
                                  />
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                ></td>
                              </tr>

                              {/* ✅ Total Calculation Row */}
                              <tr className="total-row">
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                  }}
                                ></td>
                                <td
                                  colSpan={generateRows(i)[0]?.length - 1 || 1}
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Total:
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {(() => {
                                    const totalValue = generateRows(i).reduce((acc, row) => {
                                      const lastCell = row[row.length - 1]?.item;
                                      const value = parseFloat(lastCell) || 0;
                                      return acc + value;
                                    }, 0);

                                    const totalWithRate = totalValue + (parseFloat(i.worktype_rate) || 0);
                                    i.total = totalWithRate;

                                    return totalWithRate.toFixed(2);
                                  })()}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #1a5276",
                                    padding: "8px",
                                    background: "#e5dfec",
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                ></td>
                              </tr>
                            </tbody>
                          </table>


                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}


            {formData.notes?.length > 0 && (
              <>
                <strong>
                  Final Total Table
                </strong>
                <table
                  className="nested-table-lightblue"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#eaf2f8", color: "#1a5276" }}>
                      <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>S.No.</th>
                      <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Description</th>
                      <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Amount</th>
                      <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {formData.rate?.map((item, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #1a5276", textAlign: "center" }}>{index + 1}</td>

                        <td style={{ border: "1px solid #1a5276" }}>
                          <input
                            className='input'
                            type="text"
                            value={item.description}
                            placeholder="Enter description"
                            onChange={(e) => handleRateChange(index, "description", e.target.value)}
                          />
                        </td>

                        <td style={{ border: "1px solid #1a5276" }}>
                          <input
                            className='input'
                            type="number"
                            value={item.amount}
                            placeholder="Enter amount"
                            onChange={(e) => handleRateChange(index, "amount", e.target.value)}
                          />
                        </td>
                        <td style={{ border: "1px solid #1a5276" }}>
                          {index === 0 ? (
                            <button type="button" className="viewbutton" onClick={addRateRow}>
                              <AddwithWhiteCircle /> Row
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="viewbutton"
                              onClick={() => removeRateRow(index)}

                            >
                              <CrosswithWITECircle /> Remove
                            </button>)}
                        </td>


                      </tr>
                    ))}



                    {/* Total Row */}

                  </tbody>
                </table>
              </>

            )}





          </div>
        </Modal.Body>
        <div className="button-models-gap-116 " >
          <div className="">

            <button type="button" onClick={handleClose} className="cancelbutton">Cancel</button>
          </div>

          <div className="">
            <button class="submitaddbutton" onClick={handleSubmit} type='submit'>
              <span class="text">Submit</span>
              <span class="icon">
                <svg
                  viewBox="0 0 24 24"
                  height="24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
                  </path>
                </svg>
              </span>
            </button>

          </div>

        </div>

        <p className="error-message font-size-text margin-top40px">
          {isSubmitted && Object.keys(errors).length > 0 && (
            Object.keys(errors).length > 3 ? (
              <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
            ) : (
              Object.keys(errors).map((field) =>
                field.charAt(0).toUpperCase() + field.slice(1)
              ).join(', ') + ' are required!'
            )
          )}
        </p>
      </Modal >
    </>
  );
};

const UpdateQuotations = ({ getNotes, worktypeName, getData, i }) => {
  const [formData, setFormData] = useState({
    ref_no: "",
    date: null,
    data: [{
      description: "",
    }],
    to: "",
    subject: "",
    project_details: "",
    worktype: [{
      id: "",
      name: "",
    }],
    note_ids: [],
    client_ids: [],
    notes: [],
    rate: [{
      description: ``,
      amount: ``,
    }],
    workstages: [{
      workStages: "",
      percentage: "",
    }],

    termsandconditions: [{
      item: ""
    }],

    structured_field: [
      {
        usedfor: "",
        total: "",
        work_type_rate: "",
        Data: [
          {
            heading: "",
            Data: [{
              item: "",
            }]
          }
        ]
      }
    ],

    subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",

  });


  console.log("i")
  console.log(i)




  const [subcompany, setSubCompany] = useState([])
  const getSubCompany = async () => {

    try {
      const res = await axios.get(`${BASE_URL}/project/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
    }
  };

  useEffect(() => {
    getSubCompany();
  }, [])

  const company_name = sessionStorage.getItem('sub_company_name');
  const subcompanyId = subcompany.filter(i => i.title === company_name);

  console.log("company_name", company_name);
  console.log("subcompanyId", subcompanyId);


  const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;

  console.log("company_id", company_id);

  const [clientData, setClientData] = useState([]);

  const companyids = sessionStorage.getItem('sub_company_id');

  const getClientData = async () => {

    try {
      const res = await axios.get(`${BASE_URL}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`);

      if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
        setClientData(res.data.filter(i => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"))

      }
      else {
        setClientData(res.data)

      }
    } catch (err) {
      //toast Logic
      if (err.response) {
        const errorData = err.response.data;

        if (typeof errorData.error === 'string') {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
    }
  }

  useEffect(() => {
    if (company_id !== null) {
      getClientData();
    }
  }, [company_id]);



  const [isSubmitted, setIsSubmitted] = useState(false);

  const [show, setShow] = useState(false);

  const handleShow = () => {

    setShow(true);
    setFormData(i);

    getCompany();
  }

  const handleClose = () => {
    setShow(false);


    setErrors({});
  }

  const [searchTerm, setSearchTerm] = useState("");

  const ClientListData = (clientData || [])
    .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({
      value: i.id,
      label: `${index + 1}. ${i.title}`,
    }));

  const handleClientChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        to: "",
      });
    } else {
      setFormData({
        ...formData,
        to: selectedOption.value,
      });
    }
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };
  const workTypeDatra = (worktypeName || [])
    .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({
      value: i.id,
      label: `${index + 1}. ${i.title}`,
    }));

  const handleWorkTypeChange = (selectedOptions) => {
    if (!selectedOptions) {
      setFormData({
        ...formData,
        worktype: [],
      });
    } else {
      setFormData({
        ...formData,
        worktype: selectedOptions.map(option => ({
          id: option.value,
          name: option.label.replace(/^\d+\.\s/, '')
        })),
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.worktype_id;
      return updatedErrors;
    });
  };
  useEffect(() => {
    if (!i) return;

    const NOTESdATA = Array.isArray(i)
      ? i.flatMap(item => item.notes || [])
      : (i?.notes ? i.notes : []);

    console.log("NOTESdATA:", NOTESdATA);

    setFormData(prev => ({
      ...prev,
      notes: NOTESdATA,
    }));
  }, [i]);
  useEffect(() => {
    if (!i) return;

    const STRUCTUREdETAILS = Array.isArray(i)
      ? i.flatMap(item => item.structured_field || [])
      : (i?.structured_field ? i.structured_field : []);

    console.log("structured_fielddATA:", STRUCTUREdETAILS);

    setFormData(prev => ({
      ...prev,
      structured_field: STRUCTUREdETAILS,
    }));
  }, [i]);


  useEffect(() => {
    setFormData(prev => {
      if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;

      const workstages = prev.termsandconditions.map(tc => {
        const match = tc.item.match(/^(\d+)%\s*(.*)$/);
        return {
          percentage: match ? parseFloat(match[1]) : 0,
          workStages: match ? match[2].trim() : ""
        };
      });

      return { ...prev, workstages };
    });
  }, [formData.termsandconditions]);


  console.log("formData")
  console.log(formData)

  useEffect(() => {
    if (!Array.isArray(getNotes) || !Array.isArray(formData?.worktype)) return;

    const filteredNotes = getNotes.filter(note =>
      formData.worktype.some(wt => wt?.id === note?.worktype?.id)
    );

    const newNotes = filteredNotes.filter(
      note => !formData.notes?.some(existing => existing.id === note.id)
    );

    const mergedNotes = [...(formData.notes || []), ...newNotes];
    const notesId = mergedNotes.map(note => note.id);

    setFormData(prev => ({
      ...prev,
      notes: mergedNotes,
      note_ids: notesId,
    }));
  }, [getNotes, formData.worktype]);


  useEffect(() => {
    if (!formData.worktype || formData.worktype.length === 0) {
      return;
    }

    setFormData(prev => {
      const newFields = formData.worktype.map(wt => {
        const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
        return existing || {
          usedfor: wt.name,
          Data: [
            {
              heading: "",
              Data: [{ item: "" }]
            }
          ]
        };
      });

      return {
        ...prev,
        structured_field: newFields
      };
    });
  }, [formData.worktype]);








  const addNewDescription = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      termsandconditions: [...prevFormData.termsandconditions, { item: "" }],
    }));
  };

  const handleDescriptionChange = (index, value) => {
    const updatedData = [...formData.termsandconditions];


    if (!updatedData[index]) {
      updatedData[index] = { item: "" };
    }

    updatedData[index].item = value;
    setFormData({ ...formData, termsandconditions: updatedData });


    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`item_${index}`];
        return updatedErrors;
      });
    }
  };

  const handleWorkTypeRateChange = (usedfor, value) => {
    setFormData(prev => {
      const structured_field = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          return { ...sf, worktype_rate: value };
        }
        return sf;
      });

      return { ...prev, structured_field };
    });
  };


  const fileInputRefs = useRef([]);

  const handleRemoveData = (index) => {
    setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };


  const [errors, setErrors] = useState({});

  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "null") {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });



    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };



  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {

      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true);
      try {
        let res = await axios.put(`${BASE_URL}/project/quotations/${i.id}/`, formData);

        if (res.status === 200 || res.status === 200) {
          getData();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Quotation Details Updated successfully!");

        } else {
          alert(res);
        }
      } catch (err) {
        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;

          if (typeof errorData.error === 'string') {
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach(message => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error('Error:- Failed to Process!');
          }
        } else {
          toast.error('Error processing your request.');
        }
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }

    }
  };
  const [company, setCompany] = useState([]);

  const getCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/project/subcompany/`);
      setCompany(res.data);
    } catch (error) {
      console.error(error);

    }
  }




  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value,
    });

    setFormData({
      ...formData,
      [name]: value,
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };


  const removeDescription = (index) => {
    const updatedData = formData.termsandconditions.filter((_, i) => i !== index);
    setFormData({ ...formData, termsandconditions: updatedData });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`item_${index}`];

      const reorderedErrors = {};
      Object.keys(updatedErrors).forEach((key) => {
        if (key.startsWith("item_")) {
          const idx = parseInt(key.split("_")[1], 10);
          reorderedErrors[
            `item_${idx > index ? idx - 1 : idx}`
          ] = updatedErrors[key];
        } else {
          reorderedErrors[key] = updatedErrors[key];
        }
      });

      return reorderedErrors;
    });
  };



  const [expandedTables, setExpandedTables] = useState({});

  const toggleTable = (usedfor) => {
    setExpandedTables(prev => ({
      ...prev,
      [usedfor]: !prev[usedfor]
    }));
  };

























  const addRateRow = () => {
    setFormData((prev) => ({
      ...prev,
      rate: [...prev.rate, { description: "", amount: "" }],
    }));
  };


  const removeRateRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.filter((_, i) => i !== index),
    }));
  };


  const handleRateChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };



  const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
    setFormData(prev => {
      const structured_field = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((headingObj, hIdx) => {
            if (hIdx === headingIndex) {

              const updatedItems = [...(headingObj.Data || [])];
              while (updatedItems.length <= itemIndex) {
                updatedItems.push({ item: "" });
              }
              updatedItems[itemIndex] = { item: value };
              return { ...headingObj, Data: updatedItems };
            }
            return headingObj;
          });
          return { ...sf, Data: updatedData };
        }
        return sf;
      });
      return { ...prev, structured_field };
    });
  };

  useEffect(() => {
    if (!Array.isArray(formData.worktype) || formData.worktype.length === 0) return;

    setFormData(prev => {
      const existingFields = Array.isArray(prev.structured_field) ? prev.structured_field : [];

      const newFields = formData.worktype.map(wt => {
        const existing = existingFields.find(sf => sf.usedfor === wt.name);
        return (
          existing || {
            usedfor: wt.name,
            Data: [
              {
                heading: "",
                Data: [{ item: "" }],
              },
            ],
          }
        );
      });


      const remainingFields = existingFields.filter(sf =>
        formData.worktype.some(wt => wt.name === sf.usedfor)
      );

      return {
        ...prev,
        structured_field: [...remainingFields, ...newFields],
      };
    });
  }, [formData.worktype]);




  const addNewHeading = (usedfor) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          return {
            ...sf,
            Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }]
          };
        }
        return sf;
      });

      return {
        ...prev,
        structured_field: updatedStructuredField
      };
    });
  };

  const handleRemoveDescription = (noteIndex, descIndex) => {
    setFormData((prev) => {
      const updatedNotes = [...prev.notes];
      updatedNotes[noteIndex].data = updatedNotes[noteIndex].data.filter(
        (_, i) => i !== descIndex
      );




      return { ...prev, notes: updatedNotes };
    });
  };

  const handleHeadingChange = (usedfor, headingIndex, value) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((hdg, idx) => {
            if (idx === headingIndex) {
              return { ...hdg, heading: value };
            }
            return hdg;
          });
          return { ...sf, Data: updatedData };
        }
        return sf;
      });

      return { ...prev, structured_field: updatedStructuredField };
    });
  };

  const generateRows = (structuredField) => {
    const maxLength = Math.max(...structuredField.Data.map(h => h.Data.length));

    const rows = Array.from({ length: maxLength }, (_, rowIndex) =>
      structuredField.Data.map((headingObj) => {
        return headingObj.Data[rowIndex] || { item: "" };
      })
    );

    return rows;
  };

  const addNewItemToAllHeadings = (usedfor) => {
    setFormData(prev => {
      const updatedStructuredField = prev.structured_field.map(sf => {
        if (sf.usedfor === usedfor) {
          const updatedData = sf.Data.map((headingObj) => ({
            ...headingObj,
            Data: [...headingObj.Data, { item: "" }]
          }));
          return {
            ...sf,
            Data: updatedData
          };
        }
        return sf;
      });

      return {
        ...prev,
        structured_field: updatedStructuredField
      };
    });
  };

  const handleRemoveRow = (usedfor, rowIndex) => {
    setFormData(prev => {
      const updated = { ...prev };
      const section = updated.structured_field.find(sf => sf.usedfor === usedfor);

      if (section && section.Data?.length > 0) {
        section.Data.forEach(col => {
          if (col?.Data && col.Data[rowIndex] !== undefined) {
            col.Data.splice(rowIndex, 1);
          }
        });
      }

      return { ...updated };
    });
  };


  const removeColumn = (usedfor, headingIndex) => {
    setFormData((prev) => {
      const updatedFields = prev.structured_field.map((field) => {
        if (field.usedfor === usedfor) {

          const newData = field.Data.filter((_, index) => index !== headingIndex);


          const updatedData = newData.map((headingObj) => {
            return {
              ...headingObj,
              Data: headingObj.Data.map((cellObj) => cellObj)
            };
          });

          return { ...field, Data: updatedData };
        }
        return field;
      });

      return { ...prev, structured_field: updatedFields };
    });
  };

  return (
    <>
      <button className='model-edit-button' onClick={handleShow}>
        <UpdatePencil />
      </button>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
        <Modal.Header closeButton>
          <Modal.Title>Add Quatations</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">

            <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

              <div className="flex-column ">
                <label className="form-labels">Ref. Number:<span className="required">*</span></label>
                <input
                  type="text"
                  name="ref_no"
                  value={formData.ref_no}
                  placeholder="Example:- ABCD/EFG/2025-26/456"
                  onChange={handleInputChange}
                  className={`form-input width-15vw ${errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.ref_no && <span className="error-message">{errors.ref_no}</span>}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Date:<span className="required">*</span></label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  placeholder="Example:- ABCD/EFG/2025-26/456"
                  onChange={handleInputChange}
                  className={`form-input width-15vw ${errors.date ? 'error' : inputState.date ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.date && <span className="error-message">{errors.date}</span>}
              </div>
              <div className="form-group">
                <label
                  htmlFor="to"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Client Name <span className="required">*</span>
                </label>
                <Select
                  options={ClientListData}
                  onChange={handleClientChange}
                  value={ClientListData.find(option => formData.to === option.value) || null}
                  placeholder="Select a Client"
                  isClearable
                  isSearchable
                  isMulti={false}
                  inputValue={searchTerm}
                  onInputChange={(input) => setSearchTerm(input)}
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect}
                />


                {errors.to && (
                  <div className="error-message col">
                    {errors.to}
                  </div>
                )}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Subject:<span className="required">*</span></label>
                <textarea
                  type="text"
                  name="subject"
                  value={formData.subject}
                  placeholder="Example:-  Quotation for Consultancy Services"
                  onChange={handleInputChange}
                  className={`form-input-textarea width-15vw ${errors.subject ? 'error' : inputState.subject ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.subject && <span className="error-message">{errors.subject}</span>}
              </div>
              <div className="flex-column ">
                <label className="form-labels">Project Details:<span className="required">*</span></label>
                <textarea
                  type="text"
                  name="project_details"
                  value={formData.project_details}
                  placeholder="Example:- Corporate HQ"
                  onChange={handleInputChange}
                  className={`form-input-textarea width-15vw ${errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}`}
                  style={{ width: "18vw" }}
                />
                {errors.project_details && <span className="error-message">{errors.project_details}</span>}
              </div>
              {/* <div className="form-group">
                <label
                  htmlFor="to"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  WorkType <span className="required">*</span>
                </label>
                <Select
                  options={workTypeDatra}
                  onChange={handleWorkTypeChange}
                  value={workTypeDatra.filter(option =>
                    formData.worktype?.some(wt => wt.id === option.value)
                  )}
                  placeholder="Select Work Types"
                  isClearable
                  isSearchable
                  isMulti   
                  inputValue={searchTerm}
                  onInputChange={(input) => setSearchTerm(input)}
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect}
                />
                {errors.to && (
                  <div className="error-message col">
                    {errors.to}
                  </div>
                )}
              </div> */}


              {formData.notes?.length > 0 && (
                <table className="nested-table-lightblue width-90vw payment border-table">
                  <thead className="border-table">
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>S.No.</th>
                      <th className="text-start">Notes Description</th>

                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      let serial = 1;
                      return formData.notes.map((note, noteIndex) =>
                        note.data.map((desc, descIndex) => {
                          const currentSerial = serial++;
                          return (
                            <tr key={`${note.id}-${descIndex}`}>
                              <td className="font-weight600 text-center">{currentSerial}.</td>
                              <td className="notes-description">{desc.description}</td>

                            </tr>
                          );
                        })
                      );
                    })()}
                  </tbody>
                </table>
              )}

              <div style={{ display: "flex", justifyContent: "end", width: `100%`, marginBottom: `40px` }}>

                <div className="flex-column " >

                  <button className="viewbutton" onClick={addNewDescription}>
                    <AddwithWhiteCircle />  More Conditions
                  </button>
                </div>
              </div>
              <div>


              </div>

            </div>

            <div className='flex-row justify-between' style={{ flexWrap: "wrap" }}>

              {formData.termsandconditions?.map((item, index) => (
                <div className="flex-column ">
                  <div className='flex-row justify-between'>
                    <label className="form-labels">({index + 1}).PAYMENT TERMS AND CONDITION :<span className="required">*</span></label>
                    {formData.termsandconditions.length > 1 &&


                      <button className="removebutton" onClick={() => removeDescription(index)}>
                        <span className="text"
                        >Remove</span><span className="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z">
                            </path>
                          </svg>
                        </span>
                      </button>
                    }
                  </div>

                  <input
                    type="text"
                    name={`item_${index}`}
                    value={item.item}
                    placeholder="Example:- 50% payment as ABC work"
                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                    className={`form-input ${errors[`item_${index}`] ? 'error' : inputState[`item_${index}`] ? 'success' : ''}`}
                  />
                  {errors[`item_${index}`] && (
                    <div className="error-message text-center">{errors[`item_${index}`]}</div>
                  )}                </div>
              ))}
            </div>


            {formData.notes?.length > 0 && (
              <>
                {formData.structured_field?.map((i, index) => (
                  <div key={i.usedfor}>
                    {/* 🔹 Always show each proposal section */}
                    <h6>({index + 1}). Detailed Proposal of {i.usedfor}</h6>

                    <div className="table-css-white-background scroll-container">
                      <div className="table-container scrollbar" style={{ width: "100%" }}>
                        <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                          <thead className="table-heading">
                            <tr className="custom-table-head-tr " style={{ border: "1px solid #1a5276", padding: "8px", color: "#1a5276" }}>
                              <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, color: "#1a5276" }}>S.No.</th>
                              {i.Data.map((headingObj, headingIndex) => (
                                <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }} key={headingIndex}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    <input
                                      type="text"
                                      value={headingObj.heading}
                                      placeholder="Enter heading"
                                      className='input'
                                      onChange={(e) =>
                                        handleHeadingChange(i.usedfor, headingIndex, e.target.value)
                                      }
                                    />
                                    <button
                                      type="button"
                                      style={{
                                        background: "#ff6b6b",
                                        border: "none",
                                        color: "BLACK",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                      }}
                                      onClick={() => removeColumn(i.usedfor, headingIndex)}
                                    >
                                      ×
                                    </button>
                                  </div>
                                </th>
                              ))}
                              <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>
                                <button
                                  className="viewbutton"
                                  onClick={() => addNewHeading(i.usedfor)}
                                >
                                  <AddwithWhiteCircle />  Heading
                                </button>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {generateRows(i).map((row, rowIndex) => (
                              <tr className='custom-table-head-tr ' key={rowIndex}>
                                <td style={{ border: "1px solid #1a5276", padding: "8px" }}>{rowIndex + 1}</td>

                                {row.map((cell, cellIndex) => (
                                  <td
                                    style={{
                                      border: "1px solid #1a5276", padding: "8px"
                                    }}
                                    key={cellIndex}>
                                    <input
                                      type="text"
                                      value={cell.item}
                                      className='input'
                                      placeholder="Enter item"
                                      onChange={(e) =>
                                        handleStructuredFieldChange(
                                          i.usedfor,
                                          cellIndex,
                                          rowIndex,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                ))}

                                <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
                                  {rowIndex === 0 ? (
                                    <button
                                      type="button"
                                      className="viewbutton"
                                      onClick={() => addNewItemToAllHeadings(i.usedfor)}
                                    >
                                      <AddwithWhiteCircle /> Row
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="viewbutton"
                                      onClick={() => handleRemoveRow(i.usedfor, rowIndex)}

                                    >
                                      <CrosswithWITECircle /> Remove
                                    </button>
                                  )}
                                </td>
                              </tr>

                            ))}
                            {/* ✅ Total Row */}
                            <tr className="total-row ">
                              <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
                              <td
                                style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}
                                className="text-end"
                                colSpan={generateRows(i)[0]?.length - 1 || 1}
                              >
                                {i.usedfor}
                              </td>
                              <td
                                style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>
                                <input
                                  type="number"
                                  className='input'
                                  value={i.worktype_rate || ""}
                                  placeholder="Enter work type rate"
                                  onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
                                />
                              </td>
                              <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
                            </tr>

                            <tr className="total-row ">
                              <td
                                style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
                              <td
                                colSpan={generateRows(i)[0]?.length - 1 || 1}
                                style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, textAlign: "right", fontWeight: "bold" }}
                              >
                                Total:
                              </td>
                              <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, fontWeight: "bold" }}
                              >
                                {(() => {
                                  const totalValue = generateRows(i).reduce((acc, row) => {
                                    const lastCell = row[row.length - 1]?.item;
                                    const value = parseFloat(lastCell) || 0;
                                    return acc + value;
                                  }, 0);

                                  const totalWithRate = totalValue + (parseFloat(i.worktype_rate) || 0);
                                  i.total = totalWithRate;

                                  return totalWithRate.toFixed(2);
                                })()}
                              </td>
                              <td
                                style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, textAlign: "right", fontWeight: "bold" }}
                              ></td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            <strong>
              Final Total Table
            </strong>
            {formData.notes?.length > 0 && (
              <table
                className="nested-table-lightblue"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#eaf2f8", color: "#1a5276" }}>
                    <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>S.No.</th>
                    <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Description</th>
                    <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Amount</th>
                    <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {formData.rate?.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid #1a5276", textAlign: "center" }}>{index + 1}</td>

                      <td style={{ border: "1px solid #1a5276" }}>
                        <input
                          className='input'
                          type="text"
                          value={item.description}
                          placeholder="Enter description"
                          onChange={(e) => handleRateChange(index, "description", e.target.value)}
                        />
                      </td>

                      <td style={{ border: "1px solid #1a5276" }}>
                        <input
                          className='input'
                          type="number"
                          value={item.amount}
                          placeholder="Enter amount"
                          onChange={(e) => handleRateChange(index, "amount", e.target.value)}
                        />
                      </td>
                      <td style={{ border: "1px solid #1a5276" }}>
                        {index === 0 ? (
                          <button type="button" className="viewbutton" onClick={addRateRow}>
                            <AddwithWhiteCircle /> Row
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="viewbutton"
                            onClick={() => removeRateRow(index)}

                          >
                            <CrosswithWITECircle /> Remove
                          </button>)}
                      </td>


                    </tr>
                  ))}



                  {/* Total Row */}

                </tbody>
              </table>
            )}





          </div>
        </Modal.Body>
        <div className="button-models-gap-116 " >
          <div className="">

            <button type="button" onClick={handleClose} className="cancelbutton">Cancel</button>
          </div>

          <div className="">
            <button class="submitaddbutton" onClick={handleSubmit} type='submit'>
              <span class="text">Update</span>
              <span class="icon">
                <svg
                  viewBox="0 0 24 24"
                  height="24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
                  </path>
                </svg>
              </span>
            </button>

          </div>

        </div>

        <p className="error-message font-size-text margin-top40px">
          {isSubmitted && Object.keys(errors).length > 0 && (
            Object.keys(errors).length > 3 ? (
              <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
            ) : (
              Object.keys(errors).map((field) =>
                field.charAt(0).toUpperCase() + field.slice(1)
              ).join(', ') + ' are required!'
            )
          )}
        </p>
      </Modal>
    </>
  );
};

const DeletQuotation = ({ i, getData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/project/quotations/${i.id}/`
      );

      if (res.status === 200) {
        await getData();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Quotation"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete Quotation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are You Sure, You want to Delete Quotation "{i.ref_no}"
          <div className="button-models">
            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-delete"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


const QuatationDietails = ({ worktypeName, quatationData, notesData, getData, buffer }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);



  };

  const navigate = useNavigate()

  const currentUrl = window.location.href;


  const urlParts = currentUrl.split('/');

  const baseUrl2 = "/" + urlParts[3] + `/quotationSlip`;
  const quotationPage = (id) => {
    const newUrl = baseUrl2 + `/${id}/`;
    window.open(newUrl, "_blank");
  }

  const handleBack = (e) => {
    navigate(-1);
  };



  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div >
        <div className="attendance-box">
          <div className="datagrid-container">
            <div className="custom-table-background" style={{ height: "66vh" }}>
              <div className="">
                <div className="">
                  <div className="table-box ">
                    <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

                      <AddQuatatations worktypeName={worktypeName} getNotes={notesData} getData={getData} />
                    </div>
                  </div>
                  <div className='table-box scroll-container-table'
                  >
                    <table className="table-css width-100vw">
                      <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                          <th className="table-heading ">S.no.</th>
                          <th className="table-heading text-left">Ref. No.</th>
                          <th className="table-heading text-left">Project Details</th>
                          <th className="table-heading text-left">Client</th>
                          <th className="table-heading text-left" style={{ paddingLeft: "10px" }}>View Quatation</th>
                          <th className="table-heading text-center">Action</th>
                        </tr>
                      </thead>
                      {buffer ? (

                        <div className="spinner-bgdatil"></div>

                      ) :
                        <tbody>
                          {
                            quatationData
                              .map((i, index) => (
                                <tr key={index} className="custom-table-head-td">
                                  <td>{index + 1}.</td>
                                  <td>{i.ref_no}</td>
                                  <td>{i.project_details}</td>
                                  <td>{i?.to?.client_name}</td>
                                  <td>
                                    <button className="eyebutton" onClick={(e) => quotationPage(i.id)}>view</button>

                                  </td>
                                  <td>
                                    <div className='flex-row justify-center'>

                                      <UpdateQuotations i={i} worktypeName={worktypeName} getNotes={notesData} getData={getData} />
                                      <DeletQuotation i={i} getData={getData} />
                                    </div>
                                  </td>
                                </tr>
                              ))
                          }
                        </tbody>
                      }
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default QuatationDietails;